import React from 'react';
import { Chip } from '@mui/material';
import type { LocationAssignment } from '../api/config';

interface AssignmentStatusChipProps {
  status: LocationAssignment['status'];
  size?: 'small' | 'medium';
}

export const AssignmentStatusChip: React.FC<AssignmentStatusChipProps> = ({ 
  status, 
  size = 'small' 
}) => {
  const getStatusConfig = (status: LocationAssignment['status']) => {
    switch (status) {
      case 'active':
        return {
          label: 'Active',
          color: 'success' as const,
        };
      case 'inactive':
        return {
          label: 'Inactive',
          color: 'warning' as const,
        };
      case 'discontinued':
        return {
          label: 'Discontinued',
          color: 'error' as const,
        };
      default:
        return {
          label: status,
          color: 'default' as const,
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      variant="outlined"
    />
  );
}; 